import { render, staticRenderFns } from "./AccountInvestigationHelpPopup.vue?vue&type=template&id=37bc220c&scoped=true&"
import script from "./AccountInvestigationHelpPopup.vue?vue&type=script&lang=js&"
export * from "./AccountInvestigationHelpPopup.vue?vue&type=script&lang=js&"
import style0 from "./AccountInvestigationHelpPopup.vue?vue&type=style&index=0&id=37bc220c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bc220c",
  null
  
)

export default component.exports